import React from "react";
import { Link } from "react-router-dom";
import useTitle from "../../hooks/useTitle";

const Portfolio = (props) => {
  useTitle("Portfolio")
  const {id,subtitle,img}=props.portfolio;
  return <div>
          <Link to={`/portfolio/${id}`}>
              <div>
                <img className="w-full h-56 object-cover object-top rounded-t-lg" src={img} alt="Portfolio" />
                <h3 className="text-xl font-medium py-3 bg-[#2A3343] pl-3 rounded-b-lg text-white">{subtitle}</h3>
              </div>
          </Link>
    </div>;
};

export default Portfolio;
